import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Group } from '@ogn-tracker/common/build/group';
import { Aircraft } from '@ogn-tracker/common/build/aircraft';
import { GroupQuery } from '../../../store/group/state/group.query';
import { GroupService } from '../../../store/group/state/group.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { AircraftStore } from '../../../store/aircraft/state/aircraft.store';
import { GroupStore } from '../../../store/group/state/group.store';
import { SubSink } from 'subsink';
import { AircraftService } from '../../../store/aircraft/state/aircraftService';

@Component({
  selector: 'app-groups-popup',
  templateUrl: './groups-popup.component.html',
  styleUrls: ['./groups-popup.component.scss']
})
export class GroupsPopupComponent implements OnInit, AfterViewInit, OnDestroy {
  groups$ = this.query.select('groups');
  filteredOptions: Observable<Aircraft[]>;

  selectedGroup: Group = null;
  id = new FormControl('');
  edit = false;
  name: string;
  dataSource = new MatTableDataSource<Aircraft>([]);
  columnsToDisplay = [
    'beaconType',
    'id',
    'aircraftType',
    'registrationNumber',
    'remove'
  ];
  subs = new SubSink();

  constructor(
    private service: GroupService,
    private query: GroupQuery,
    public store: GroupStore,
    private aircraftStore: AircraftStore,
    private aircraftService: AircraftService,
    private snackbar: MatSnackBar
  ) {
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.subs.sink = this.service.getGroups().subscribe();
    this.subs.sink = this.aircraftService.getAircrafts().subscribe();
    this.filteredOptions = this.id.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  newGroup(): void {
    const group = {} as Group;
    group.name = 'Csoport ' + ((this.store.getValue().groups?.length ?? 0) + 1);
    this.subs.sink = this.service.postGroup(group).subscribe(response => {
      if (response.message === 'success') {
        this.subs.sink = this.service.getGroups().subscribe();
      }
    });
  }

  renameGroup(): void {
    if (this.store.getValue().groups.find((g) => g.name === this.name) !== undefined) {
      this.snackbar.open('Ilyen nevű csoport már létezik!');
      return;
    }
    this.selectedGroup.name = this.name;
    this.name = null;
    this.subs.sink = this.service
      .patchGroupById(this.selectedGroup)
      .subscribe((_) => {
        this.edit = false;
        this.getGroup(this.selectedGroup.id);
      });
  }

  deleteGroup(): void {
    this.subs.sink = this.service.deleteGroupById(this.selectedGroup.id).subscribe(
      (_) => {
        this.selectedGroup = null;
        this.subs.sink = this.service.getGroups().subscribe();
        this.snackbar.open('Csoport törölve!');
      },
      (_) => this.snackbar.open('Törölés sikertelen!')
    );
  }

  addAircraft(): void {
    this.selectedGroup.aircrafts.push(this.getAircraft(this.id.value));
    this.id.setValue('');
    this.subs.sink = this.service.patchGroupById(this.selectedGroup).subscribe(
      _ => this.getGroup(this.selectedGroup.id),
      _ => this.snackbar.open('Sikertelen!')
    );
  }

  removeAircraft(aircraft: Aircraft): void {
    this.selectedGroup.aircrafts = this.selectedGroup.aircrafts.filter((b) => b !== aircraft);
    this.subs.sink = this.service.patchGroupById(this.selectedGroup).subscribe(
      _ => this.getGroup(this.selectedGroup.id),
      _ => this.snackbar.open('Sikertelen!'));
    this.id.setValue('');
  }

  getGroup(id: number): void {
    this.subs.sink = this.service.getGroupById(id).subscribe(group => {
      this.selectedGroup = group;
      this.dataSource.data = group.aircrafts;
      this.name = group.name;
    });
  }

  private _filter(value: string): Aircraft[] {
    const filterValue = value.toLowerCase();
    return this.aircraftStore.getValue().aircrafts
      .filter(aircraft => this.notInSelectedGroup(aircraft))
      .filter(aircraft => aircraft.deviceId.toLowerCase().indexOf(filterValue) === 0);
  }

  notInSelectedGroup(aircraft: Aircraft): boolean {
    let contains = false;
    this.selectedGroup.aircrafts.forEach(b => {
        if (b.id === aircraft.id) {
          contains = true;
        }
      }
    );
    return !contains;
  }

  getAircraft(id: string): Aircraft {
    return this.aircraftStore.getValue().aircrafts.find(b => b.deviceId === id);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
